import { NavLink, Outlet, useLocation } from "react-router-dom";
import { ShoppingCart } from "@mui/icons-material";
import { Badge, Box, Button, Container, Tooltip } from "@mui/material";
// components
import Menu from "./Menu";
//
import { NAVBAR_WIDTH } from "./constants";
import useResponsive from "../hooks/useResponsive";
import useAppContext from "../hooks/useAppContext";
import AppBar from "./AppBar";

export default function Layout() {
  const isDesktop = useResponsive('up', 'lg');

  const { cart } = useAppContext();
  const { pathname } = useLocation();

  return (
    <Container maxWidth={'unset'} sx={{ p: '0 !important', m: 0 }}>
      {isDesktop &&
        <AppBar />
      }

      <Menu />

      <Box
        component='main'
        sx={
          isDesktop ? {
            ml: `${NAVBAR_WIDTH}px`,
            // width: `calc(100vw - ${NAVBAR_WIDTH}px)`
          } : { width: '100%' }
        }
      >
        <Outlet />
      </Box>

      {Boolean(cart?.length) && pathname !== '/carrinho' && pathname !== '/auth' && pathname !== '/login' &&
        <Box
          sx={{ position: 'fixed', bottom: 10, right: 10 }}
        >
          <Tooltip title='Meu Carrinho'>
            <Button
              variant="contained"
              component={NavLink}
              to='/carrinho'
              color="success"
              sx={{ p: 1.5 }}
              startIcon={
                <Badge
                  badgeContent={cart.length}
                  overlap="circular"
                  color="error"
                >
                  <ShoppingCart fontSize="large" />
                </Badge>
              }
            >
              Finalizar Pedido
            </Button>
          </Tooltip>
        </Box>
      }
    </Container >
  )
}